import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireSrc } from "../node_modules/postcss-discard-duplicates/src/index.js";
var srcExports = requireSrc();
const discardDuplicates = /* @__PURE__ */ getDefaultExportFromCjs(srcExports);
export {
  discardDuplicates as default
};
//# sourceMappingURL=index.js.map
